import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import App from './components/app';
import loadData from './actions/loadData';
import fetchData from './actions/fetchData';
import rootReducer from './reducers';

require('./ie11Polyfills');

const stores = [];

/** We need to do this over EVERY INSTANCE OF COMPONENTS... */
[].forEach.call(
  document.querySelectorAll('[kff-indicator-components]'),
  (component, idx) => {
    // Create store with redux-thunk middleware,
    // which allows us to async things in the actions
    stores[idx] = createStore(
      rootReducer,
      composeWithDevTools(applyMiddleware(thunk))
    );

    // Make reducers hot reloadable, see http://stackoverflow.com/questions/34243684/make-redux-reducers-and-other-non-components-hot-loadable
    if (module.hot) {
      module.hot.accept('./reducers/', () => {
        const nextRoootReducer = require('./reducers/').default; // eslint-disable-line global-require
        stores[idx].replaceReducer(nextRoootReducer);
      });
    }

    /**
     * We load in initial data from the dom, because this is generated from a
     * shortcode we cannot expect unique data in a global...
     */
    const appJs = JSON.parse(component.getAttribute('data-app-js'));
    const {
      gdocs_object: gdocsObject,
      gdocs_key: gdocsKey,
      type,
      sortable,
      show_footnotes: showFootnotes,
      show_notes: showNotes,
    } = appJs;

    /**
     * Check if gdocsObject has data (did wordpress save it in transient),
     * if not we need to fetch the data ourselves
     */
    if (false !== gdocsObject) {
      stores[idx].dispatch(
        loadData(gdocsObject, type, sortable, showFootnotes, showNotes, idx)
      );
    } else {
      stores[idx].dispatch(fetchData(
        gdocsKey,
        type,
        sortable,
        showFootnotes,
        showNotes,
        idx
      ));
    }

    ReactDOM.render(
      <Provider store={stores[idx]}>
        <App appIndex={idx} />
      </Provider>,
      component
    );
  }
);



// WEBPACK FOOTER //
// ./app/main.js